import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSelectMoveTool = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.89661 3.15265C2.83907 2.99331 2.99331 2.83907 3.15265 2.89661L21.5721 9.5481C22.0611 9.72467 22.1094 10.3972 21.6507 10.6418L14.7396 14.3278C14.5645 14.4212 14.4212 14.5645 14.3278 14.7396L10.6418 21.6507C10.3972 22.1094 9.72467 22.0611 9.5481 21.5722L2.89661 3.15265ZM5.24811 5.24811L10.2712 19.1582L13.2191 13.6309C13.3125 13.4558 13.4558 13.3125 13.6309 13.2191L19.1582 10.2712L5.24811 5.24811Z",
		fill: "currentColor"
	})
});
export { SvgIconSelectMoveTool as ReactComponent };
